var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Sidebar',{staticClass:"seller-sidebar",on:{"logout":_vm.handleLogout}}),_c('v-main',[_c('div',{staticClass:"seller-content",class:{ 'seller-content--mobile': _vm.$vuetify.breakpoint.smAndDown }},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }